import { createContext, useContext } from "react";

export type ShowToast = (message: string) => void;

/** GRF-27: a short visible confirmation at the bottom of the window. Screen readers hear it through the announcer. */
export const ToastContext = createContext<ShowToast>(() => undefined);

export function useToast(): ShowToast {
  return useContext(ToastContext);
}
